import { render, staticRenderFns } from "./HotCard.vue?vue&type=template&id=7f913e08&scoped=true&"
import script from "./HotCard.vue?vue&type=script&lang=js&"
export * from "./HotCard.vue?vue&type=script&lang=js&"
import style0 from "./HotCard.vue?vue&type=style&index=0&id=7f913e08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f913e08",
  null
  
)

export default component.exports